<template>
  <div>
    <b-alert show variant="info" class="mb-2 p-2">
      <div class="d-flex align-items-center">
        <feather-icon icon="InfoIcon" size="24" class="mr-1" />
        <span>{{ $t('Please select a provider to continue managing additional services') }}</span>
      </div>
    </b-alert>
    <ProviderTableSelection @select="handleSelect" />
  </div>
</template>

<script>
import ProviderTableSelection from '@/components/ProviderTableSelection.vue';
import { BAlert } from 'bootstrap-vue';

export default {
  name: 'CostPricesAdditionalServicesProviderSelection',
  components: {
    BAlert,
    ProviderTableSelection
  },
  methods: {
    handleSelect(provider) {
      this.$router.push({
        name: 'cost-prices-additional-services-detail',
        params: { providerId: provider.id }
      });
    }
  }
};
</script>
